<template>
  <div>
    <headers />

    <!-- <keep-alive
      :include="[
        'Ztzl',
        'Index',
        'Gaikuang',
        'Gzly',
        'Search',
        'MonList',
        'GonggaoList',
        'Maps',
      ]" -->
    <keep-alive
      :include="[
        //暂时去掉Gaikuang，早晚会加回来的
        'Ztzl',
        'Index',
        'Gzly',
        'Search',
        'MonList',
        'GonggaoList',
        'Maps',
      ]"
      ><router-view></router-view>
    </keep-alive>

    <fotters />
  </div>
</template>

<script>
import headers from "./components/headers";
import fotters from "./components/fotters";

export default {
  name: "App",
  components: {
    headers,
    fotters,
  },
};
</script>

<style>
@import "../vab/styles/header.css";
@import "../vab/styles/common.css";
</style>
